import {Pressable, Text, StyleSheet, View} from "react-native";
import React, {useState} from "react";
import {FontAwesome} from "@expo/vector-icons";
import {useDispatch, useSelector} from "react-redux";
import {useTheme} from "@react-navigation/native";
import {useTranslation} from "react-i18next";
import {AsyncDispatch} from "../function/functions";

export default function DeleteTaskButton(props) {
    const {  title = 'Edit', navigation, id, completed } = props;
    const tasks = useSelector(state => state.tasks);
    const [removeTask, setRemoveTask] = useState(false);
    const dispatch = useDispatch();
    const theme = useTheme();

    const {t, i18n} = useTranslation();
    const styles = StyleSheet.create({

        buttonRemove: {
            width: 32,
            height: 32,
            backgroundColor: theme.colors.scheme[1],
            fontFamily: 'Roboto-Regular',
            marginHorizontal: 2,
            padding: 0,
            lineHeight: 32,
            borderWidth: 0,
            borderRadius: 100,
            justifyContent: 'center',
            alignItems: 'center',
            position:'absolute',
            right:0
        },
        buttonBack: {
            width: 32,
            height: 32,
            backgroundColor: theme.colors.scheme[3],
            fontFamily: 'Roboto-Regular',
            marginHorizontal: 2,
            padding: 0,
            lineHeight: 32,
            borderWidth: removeTask ? 2 : 0,
            borderColor:theme.colors.scheme[6],
            borderRadius: 100,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: theme.colors.scheme[2],
            shadowOpacity: 0.75,
            shadowRadius:12
        },
        buttonDelete: {
            display:'flex',
            flexDirection:'row',
            flexWrap:'nowrap',
            height: 32,
            backgroundColor: theme.colors.scheme[1],
            fontFamily: 'Roboto-Regular',
            marginHorizontal: 2,
            padding: 0,
            lineHeight: 32,
            borderWidth: 0,
            borderRadius: 100,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: theme.colors.scheme[2],
            shadowOpacity: 0.75,
            shadowRadius:12
        }
    });
    function deleteTask(id, completed) {
        setRemoveTask(false);
        AsyncDispatch(dispatch,"REMOVE_TASK", {id:id, complete:completed}).then(() => {
            dispatch({type: 'SAVE_TASK', payload:[]});
        })
    }
    return (
        <View style={{position:'absolute', top:0, right:0, borderWidth:0}}>
            <Pressable style={({pressed}) => [styles.buttonRemove, {display: (removeTask ? 'none' : 'flex'), opacity: pressed ? 0.5 : 1}]} onPress={() => setRemoveTask(true)}>
                <FontAwesome style={{fontSize:18, color:theme.colors.scheme[4]}} name={'remove'} />
            </Pressable>
            <View style={{position: 'absolute', right:0, display:'flex', flexDirection:'row', flexWrap:'nowrap'}}>
                <Pressable style={({pressed}) => [styles.buttonBack, {display: (removeTask ? 'flex' : 'none'), opacity: pressed ? 0.5 : 1}]} onPress={() => setRemoveTask(false)}>
                    <FontAwesome style={{fontSize:18, color:theme.colors.scheme[2]}} name={'arrow-left'} />
                </Pressable>
                <Pressable style={({pressed}) => [styles.buttonDelete, {display: (removeTask ? 'flex' : 'none'), opacity: pressed ? 0.5 : 1, paddingHorizontal: 12}]} onPress={() => deleteTask(id, completed)}>
                    <FontAwesome style={{fontSize:18, color:theme.colors.scheme[4]}} name={'remove'} /><Text style={{color:theme.colors.scheme[4], fontWeight:'bold', paddingLeft:8, fontSize: 12}}>{t('task.delete')}</Text>
                </Pressable>
            </View>
        </View>
    );
}
